import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {CompetitionImportService} from "../../../shared/services/competition-import.service";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {CompetitionImport} from "../../../shared/interface/competition-import";
import {NgForm} from "@angular/forms";
import {IMPORT_STATUS_IN_PROGRESS} from "../../../shared/services/dict.service";

@Component({
  selector: 'app-competition-list',
  templateUrl: './competition-list.component.html',
  styleUrls: ['./competition-list.component.scss']
})
export class CompetitionListComponent implements AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  displayedColumns: string[] = [
    'competitionName',
    'importRow',
  ];

  sortBy = null;
  sortOrder = null;
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  imports: CompetitionImport[] = [];
  readonly IMPORT_STATUS_IN_PROGRESS = IMPORT_STATUS_IN_PROGRESS;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private competitionImportService: CompetitionImportService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.competitionImportService.importListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<CompetitionImport>) => {
          this.imports = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      contains$competitionName: 'string',
    }, filters);
  }



  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path,
        this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value
        })
      ]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.competitionImportService.loadImportList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.initialFilters
    );
  }


  filter(): void {
    const formValues = { ...this.filtersForm.value };

    for (const key in formValues) {
      if (formValues[key] === undefined || formValues[key] === null || formValues[key] === '') {
        delete formValues[key];
      }
    }

    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path,
      this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...formValues
      })
    ]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();

    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }


}
